//router.js
import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";


import Login from "../portal/Login";
import Register from '../portal/register';
import tokenLogin from '../portal/tokenLogin';
import Frame from '../frame/Frame';
import Home from '../frame/Home';
import Demo from '../pages/home/Demo';

import HomePage from '../pages/home/index';
import AIChat from '../pages/AIChat/AIChat';
import EnterpriseSearch from '../pages/enterprise';
import RecommendedJob from '../pages/recommendedJob/index'
import EnterpriseDetail from '../pages/enterprise/detail';
import Applicant from '../pages/applicant/index'

import Internship from '../pages/internship/index';
import PartTimeJob from '../pages/partTimeJob/index';
import PartTimeSearch from '../pages/partTimeJob/partTimeSearch';
import PersonalCenter from '../pages/personalCenter';
import MessageCenter from '../pages/messageCenter/index';
import Mes_info from '../pages/messageCenter/mes_info';
import ChoiceExpect from '../pages/personalCenter/choiceExpect/index'; 
import Account_setting from '../pages/account_setting/index';
import Personal_planning  from '../pages/personalPlanning/index';
import TestReport from '../pages/personalPlanning/testReport';

import SendNotice from '../pages/recommendedJob/sendNotice';
import JobDetails from '../pages/com/Detail_info/detail_info';
import Profession from '../pages/profession';
import ProfessionDetail from '../pages/profession/detail';
// import JobDetails from '../pages/com/jobdetails/jobdetails';

import ResumeNewPage from '../pages/resume/ResumeNewPage';
import PrivacyPolicy from '../portal/PrivacyPolicy';
import ServiceAgreement from '../portal/ServiceAgreement';
import LicensePage from '../frame/LicensePage';

import CareerSeek from '../pages/Career/CareerSeek';
import CareerExplore from '../pages/Career/CareerExplore';
import CareerPlanning from '../pages/Career/CareerPlanning';
import CareerExploreAI from '../pages/Career/CareerExploreAI';
import CareerEvaluation from '../pages/Career/CareerEvaluation';
import CareerEvaluationInfo from '../pages/Career/CareerEvaluationInfo';
import CareerEvaluationTest from '../pages/Career/CareerEvaluationTest';

import Config from '../config/Config';
let baseRoutePath = Config.getBaseRoutePath();
class FrameRouter extends React.Component {
    render() {
        return ( 
            <Router basename={baseRoutePath}>
                <FrameRoute exact path={"/"} component={HomePage} model={"table"} />
                {/* <Route exact path="/" component={HomePage}></Route> */}
                <Route path="/Login" component={Login}></Route>
                <Route path="/tokenLogin" component={tokenLogin}></Route>
                <Route path="/register" component={Register}></Route>
                <Route path="/license/:id" component={LicensePage}></Route>
                <Route path="/home" render={({ match }) => {
                    let access = true
                    let token = true

                    // let access = sessionStorage.getItem("_user_access_");
                    // let token = sessionStorage.getItem("_user_token_"); 

                    let URL = window.location.pathname;
                    if (URL.indexOf('null') > -1) {
                        URL = '/home'
                    }
                    else {
                        URL = URL.replace("/recruit", "");
                    }

                    sessionStorage.setItem("_redirect_source_url", URL);
                    if (access || token) {
                        let pathBase = match.path;

                        return (
                            <Router basename={baseRoutePath}>
                                <Switch>
                                    <FrameRoute exact path={pathBase + "/homepage"} component={HomePage} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/recommendedJob"} component={RecommendedJob} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/jobdetails"} component={JobDetails} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/applicant"} component={Applicant} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/sendNotice"} component={SendNotice} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/internship"} component={Internship} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/partTimeJob"} component={PartTimeJob} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/partTimeSearch"} component={PartTimeSearch} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/personalCenter"} component={PersonalCenter} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/messageCenter"} component={MessageCenter} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/messageCenter/mes_info"} component={Mes_info} model={"table"} />

                                    <FrameRoute exact path={pathBase + "/choiceExpect"} component={ChoiceExpect} model={"table"} />

                                    <FrameRoute exact path={pathBase + "/account_setting"} component={Account_setting} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/personal_planning"} component={Personal_planning} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/testReport"} component={TestReport} model={"table"} />
                                    

                                    <FrameRoute exact path={pathBase + "/ai-chat"} component={AIChat} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/enterprise"} component={EnterpriseSearch} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/enterprise/detail"} component={EnterpriseDetail} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/profession"} component={Profession} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/profession/detail"} component={ProfessionDetail} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/resume"} component={ResumeNewPage} model={"table"} />
                                    {/* <FrameRoute exact path={pathBase + "/resume-new"} component={ResumeNewPage} model={"table"} /> */}
                                    <FrameRoute exact path={pathBase + "/privacy-policy"} component={PrivacyPolicy} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/service-agreement"} component={ServiceAgreement} model={"table"} />

                                    <FrameRoute exact path={pathBase + "/career-planning"} component={CareerPlanning} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/career-explore"} component={CareerExplore} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/career-explore-ai"} component={CareerExploreAI} model={"table"} />
                                    <FrameRoute exact path={pathBase + "/career-seek"} component={CareerSeek} model={"table"} /> 
                                    <FrameRoute exact path={pathBase + "/career-evaluation"} component={CareerEvaluation} model={"table"} /> 
                                    <FrameRoute exact path={pathBase + "/career-evaluation-info/:id"} component={CareerEvaluationInfo} model={"table"} /> 
                                    <FrameRoute exact path={pathBase + "/career-evaluation-test"} component={CareerEvaluationTest} model={"table"} /> 

                                     
                                </Switch>
                            </Router>
                        )
                    }
                    else {
                        return (
                            <Redirect to="/Login" />
                        )
                    }
                }} ></Route>
            </Router>
        )
    }
}

const FrameRoute = ({ component: Component, model, ...rest }) => (
    <Route {...rest} render={(props) => (
        <Frame model={model} >
            <Component {...props} />
        </Frame>
    )} />
)


export default FrameRouter


